import { render, staticRenderFns } from "./LeaderboardTotalReturnRenderer.vue?vue&type=template&id=12763850&"
import script from "./LeaderboardTotalReturnRenderer.vue?vue&type=script&lang=js&"
export * from "./LeaderboardTotalReturnRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports